import React from 'react';
import { Link } from 'react-router-dom';

export default (props) => {
    return (
        <div className="row">
            <div className="col-12">
                <div className="card m-b-20">
                    <div className="card-block">
                        <div className='row'>
                            <div className="col-sm-6">
                                <h1 className="mb-3">{props.title}</h1>
                            </div>
                            { props.creationLink ? (
                                <div className="col-sm-6 pt-2">
                                    <Link
                                        to={props.creationLink}
                                        className="btn btn-primary waves-effect pull-right"
                                    >
                                        {props.creationLabel}</Link>
                                </div>
                            ) : null }

                        </div>
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./web/src/components/Card.jsx